import { HStack, NextLink } from "goi_common";
import { useRouter } from "next/router";

import Tab from "@/components/Tab";

type TabEndPoint = "introduce" | "guide" | "funeral";
type TabKey = "상조 소개" | "피해 보상" | "장례 준비";

const TAB_DATAS: Record<TabKey, TabEndPoint> = {
  "상조 소개": "introduce",
  "피해 보상": "guide",
  "장례 준비": "funeral",
};

export const ClosedSangjoMenuTabs = () => {
  const router = useRouter();
  const { query, route } = router;

  const lastPath = route.split("/").at(-1);
  const id = query?.id as string;

  return (
    <nav>
      <HStack gap="60px" justifyContent="space-evenly">
        {Object.entries(TAB_DATAS).map(([text, endPoint]) => (
          <NextLink key={text} href={`/sangjo/closed/${id}/${endPoint}`}>
            <Tab onClick={() => {}} isActive={lastPath === endPoint}>
              {text}
            </Tab>
          </NextLink>
        ))}
      </HStack>
    </nav>
  );
};
